import React from "react";

/** Palette dérivée des couleurs de l'app. */
const COLORS = ["#027AFC", "#003B7F", "#0E9F6E", "#F59E0B", "#7C3AED"];

const getInitials = (name) =>
  String(name ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "?";

/**
 * Avatar d'un enfant : ses initiales sur une couleur stable,
 * pour le repérer d'un coup d'œil dans la liste.
 */
function EnfantAvatar({ id, name, size = 44, className = "" }) {
  const color = COLORS[Math.abs(parseInt(id, 10) || 0) % COLORS.length];

  return (
    <div
      className={`rounded-full flex items-center justify-center shrink-0 text-white font-extrabold ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        fontSize: size * 0.38,
        letterSpacing: 0.5,
      }}
    >
      {getInitials(name)}
    </div>
  );
}

export default EnfantAvatar;
